import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Paper,
  TextField,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import Draggable from 'react-draggable';
import Button from 'components/Button/button';
import { useHistory } from 'react-router-dom';
import Environment from 'utils/environments';
import moment from 'moment/moment';
import getOptions from 'services/getOptions';
import DefaultImage from 'images/defaultAndEmpties/defaultNoProductImageMediumRectangleLightGrayBg.svg';
import HistoryInfosIcon from 'images/icons/objects/clocks/clockArrowBackLightBlueWhiteBgRoundedLightBlueBorder.svg';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import ValidationLength from 'utils/utils';
import {
  LabelPrintConfigDialogContainer,
  PrintProductTopInfos,
  PrintProductBottomInfos
} from '../../styles';
import CommonAlert from 'components/CommonAlert/CommonAlert';
import { Autocomplete } from '@material-ui/lab';
import ConfirmModal from 'components/Dialogs/ConfirmModal/ConfirmModal';
import SimplifiedValidityCards from '../../components/ValidityFilter/SimplifiedValidityCards';
import StockExtractDialog from '../StockExtractDialog';


function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggableLabelPrintConfigDialog"
      cancel={'input,textarea,button,[class*="MuiInputBase-root"],[role="button"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

const environment = Environment(process.env.REACT_APP_ENV);

const PREV_LABEL_STATUS_MODEL = {
  ON_DATE: 'ON_DATE',
  VALID: 'VALID',
  EXPIRED: 'EXPIRED'
};

function LabelPrintConfigDialog({
  open,
  onClose,
  onSubmit,
  selectedProduct,
  userInfo,
  updateMainList
}) {
  const { id: paramsID } = useParams();
  const userLocal = JSON.parse(localStorage.getItem('companies'));
  const history = useHistory();
  const profile = userInfo?.profile[0][0]?.name;
  const isLabelAdmin = profile === 'admin_label';
  const currentUserId = isLabelAdmin ? userLocal?.labelId : paramsID;
  const inputRef = useRef();
  const autocompleteRef = useRef();
  const isMobileScreen = useMediaQuery('(max-width: 866px)');
  const isSmallTablet = useMediaQuery('(max-width: 602px)');
  const isPhoneScreen = useMediaQuery('(max-width: 576px)');
  const [manipulationFormattedDate, setManipulationFormattedDate] = useState(
    selectedProduct ? moment().format('DD/MM/YYYY HH:mm') : '00/00/0000 00:00'
  );
  const [currentUserInfos, setCurrentUserInfos] = useState(
    selectedProduct ? userInfo?.user : 'Usuário'
  );
  const [product, setProduct] = useState({ numberOfLabels: '1' });
  const [productOptions, setProductOptions] = useState([]);
  const [productDescription, setProductDescription] = useState();
  const [loading, setLoading] = useState(false);
  const [debounceTimeList, setDebounceTimeList] = useState([]);
  const [message, setMessage] = useState({
    description: '',
    status: ''
  });
  const [internalDialogSettings, setInternalDialogSettings] = useState([
    { id: 1, name: 'confirmDialog', open: false, fullScreen: false },
    {
      id: 2,
      name: 'stockExtractDialog',
      open: false
    }
  ]);
  const prevLabelStatus =
    PREV_LABEL_STATUS_MODEL[history?.location?.state?.labelStatus] || null;
  const [validityFilterInfos, setValidityFilterInfos] = useState();

  const getFormattedValidityDate = () => {
    if (isNaN(selectedProduct?.expirationDuration)) {
      return '00/00/0000 00:00';
    }

    const baseDate =
      selectedProduct.expirationType == 'HOUR'
        ? moment().add(selectedProduct.expirationDuration, 'hours')
        : moment().add(selectedProduct.expirationDuration, 'days');

    return selectedProduct.validAtType === 'END_OF_DAY' ||
      (selectedProduct.expirationType == 'DAY' &&
        selectedProduct.expirationDuration == 0)
      ? baseDate.endOf('day').format('DD/MM/YYYY HH:mm')
      : baseDate.format('DD/MM/YYYY HH:mm');
  };

  const [validityFormattedDate, setValidityFormattedDate] = useState(
    getFormattedValidityDate
  );

  const getProductsOptions = (value) => {
    debounceTimeList.forEach((el) => clearTimeout(el));

    const newTimer = setTimeout(() => {
      getOptions(
        `${environment.catalog}/printer/products`,
        'productOptions',
        productOptions,
        setProductOptions,
        currentUserId,
        {
          ...(value && { productDescription: value })
        },
        null,
        10,
        '',
        '',
        'restaurantId'
      );
    }, 1500);

    setDebounceTimeList([...debounceTimeList, newTimer]);
  };

  useEffect(() => {
    if (!open) return;

    setTimeout(() => {
      if (!selectedProduct) {
        const input = autocompleteRef.current?.querySelector('input');
        input?.focus();
      } else {
        const input = inputRef.current;
        if (input) {
          input.click();
          input.focus();
          input.setSelectionRange?.(9999, 9999);
        }
      }
    }, 300);
  }, [open, selectedProduct]);

  useEffect(() => { }, [currentUserId]);

  useEffect(() => {
    if (selectedProduct) {
      setProduct({
        ...selectedProduct,
        numberOfLabels: selectedProduct?.numberOfLabels || '1'
      });

      setInternalDialogSettings(
        internalDialogSettings.map((modal) =>
          modal.name === 'stockExtractDialog'
            ? {
              ...modal,
              initialProduct: selectedProduct || null
            }
            : modal
        )
      );

      setValidityFilterInfos({
        ...validityFilterInfos,
        content: [
          {
            labelStatus: 'EXPIRED',
            total: selectedProduct?.expiredCount
          },
          {
            labelStatus: 'ON_DATE',
            total: selectedProduct?.onDateCount
          },
          {
            labelStatus: 'VALID',
            total: selectedProduct?.validCount
          }
        ],
        loading: false
      });
    }
  }, []);

  return (
    <LabelPrintConfigDialogContainer
      className="defaultModal"
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperComponent={PaperComponent}
    >
      {!selectedProduct ? (
        <Autocomplete
          freeSolo
          onChange={(_, value) => {
            setInternalDialogSettings(
              internalDialogSettings.map((modal) =>
                modal.name === 'stockExtractDialog'
                  ? {
                    ...modal,
                    initialProduct: value || null
                  }
                  : modal
              )
            );
            setValidityFilterInfos({
              ...validityFilterInfos,
              content: [
                {
                  labelStatus: 'EXPIRED',
                  total: value?.expiredCount
                },
                {
                  labelStatus: 'ON_DATE',
                  total: value?.onDateCount
                },
                {
                  labelStatus: 'VALID',
                  total: value?.validCount
                }
              ],
              loading: false
            });
            setProduct({
              ...value,
              numberOfLabels: value?.numberOfLabels || '1'
            });
            setManipulationFormattedDate(moment().format('DD/MM/YYYY HH:mm'));

            let baseDate =
              value.expirationType == 'HOUR'
                ? moment().add(value.expirationDuration, 'hours')
                : moment().add(value.expirationDuration, 'days');

            baseDate =
              value.validAtType === 'END_OF_DAY' ||
                (value.expirationType == 'DAY' && value.expirationDuration == 0)
                ? baseDate.endOf('day').format('DD/MM/YYYY HH:mm')
                : baseDate.format('DD/MM/YYYY HH:mm');

            setValidityFormattedDate(baseDate);
            setCurrentUserInfos(userInfo?.user);
            setProductDescription(value?.description || '');

            setTimeout(() => {
              inputRef.current?.focus();
            }, 100);
          }}
          className="autocompleteSmall productFilterAutocomplete"
          fullWidth
          size="small"
          variant="outlined"
          getOptionLabel={(option) => option?.description}
          options={productOptions}
          value={product || null}
          inputValue={productDescription || ''}
          onFocus={() => {
            if (!productOptions?.length) getProductsOptions();
          }}
          onInputChange={(_, value, reason) => {
            if (reason === 'input') {
              setProductDescription(value);
              getProductsOptions(value);
            }

            if (reason === 'clear') {
              setProductDescription(null);
              setProduct(null);
            }
          }}
          renderInput={(params) => (
            <div ref={autocompleteRef}>
              <TextField
                {...params}
                id={params?.id}
                name="product"
                placeholder="Selecione o Produto..."
              />
            </div>
          )}
          renderOption={(option) => (
            <Typography style={{ fontSize: '12px', fontFamily: 'Lato' }}>
              {option?.description}
            </Typography>
          )}
        />
      ) : null}

      {!isLabelAdmin && (
        <div className="validityInfosBox">
          <SimplifiedValidityCards
            initialActive={prevLabelStatus ? [prevLabelStatus] : []}
            validityFilterInfos={validityFilterInfos}
            hasSelectedProduct={selectedProduct}
            onClick={() => {
              setInternalDialogSettings(
                internalDialogSettings.map((modal) =>
                  modal.name === 'stockExtractDialog'
                    ? {
                      ...modal,
                      initialProduct:
                        selectedProduct || modal?.initialProduct || null,
                      open: true
                    }
                    : modal
                )
              );
            }}
          />
        </div>
      )}

      {loading ? <LinearProgress /> : null}

      <section
        className={`dialogContainer ${!selectedProduct && !product && 'newPrintProductConfig'
          } ${!selectedProduct && 'noBorderTop'}`}
      >
        <DialogContent
          id="draggableLabelPrintConfigDialog"
          className="cursorMove pRelative"
        >
          <PrintProductTopInfos>
            <div className="productDescriptionAndStockValue  mr8">
              <span className="title">
                {ValidationLength(
                  product?.description
                    ? `${product?.description} ${product?.conservation
                      ? `(${product?.conservation?.abbreviation?.toUpperCase()})`
                      : ''
                    }`
                    : 'PRODUTO',
                  isPhoneScreen ? 70 : 50
                )}
              </span>

              <span className="defaultItemLine">
                QTDE:{' '}
                <span className="lineValue">
                 {product?.labelQuantity || '0,000'}
                </span>
                <span>
                   {' '} {product?.consumptionUnitsPrimary?.abbreviation}
                </span>
              </span>
            </div>

            <img
              src={product?.image?.url || DefaultImage}
              alt={product?.image?.url}
            />
          </PrintProductTopInfos>

          <PrintProductBottomInfos>
            <span className="defaultItemLine">
              Manipulação:{' '}
              <span className="lineValue">{manipulationFormattedDate}</span>
            </span>

            <span className="defaultItemLine">
              Validade:{' '}
              <span className="lineValue">{validityFormattedDate}</span>
            </span>

            <span className="defaultItemLine">
              Responsável: <span className="lineValue">{currentUserInfos}</span>
            </span>
          </PrintProductBottomInfos>

          <img
            className="pAbsolute"
            style={{ bottom: '5%', right: '3%' }}
            onClick={() => {
              setInternalDialogSettings(
                internalDialogSettings.map((modal) =>
                  modal.name === 'stockExtractDialog'
                    ? {
                      ...modal,
                      initialProduct:
                        selectedProduct || modal?.initialProduct || null,
                      open: true
                    }
                    : modal
                )
              );
            }}
            src={HistoryInfosIcon}
            alt={HistoryInfosIcon}
          />
        </DialogContent>

        <DialogActions>
          <p className="textAlignRight">NOVA {!isPhoneScreen && 'ETIQUETA'}</p>

          <TextField
            id="labelPrintProductQuantity"
            inputRef={inputRef}
            className="textFieldSmall right childInputP0 childInputW100 childInputFontSize20"
            placeholder={isPhoneScreen ? 'Qtde...' : 'Defina a Qtde...'}
            variant="outlined"
            fullWidth
            type="text"
            value={product?.labelQuantity}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 15
            }}
            onChange={(e) => {
              const raw = e.target.value.replace(/\D/g, '');
              const padded = raw.padStart(4, '0');
              const integerPart = padded.slice(0, -3);
              const decimalPart = padded.slice(-3);
              const numeric = parseFloat(
                `${parseInt(integerPart, 10)}.${decimalPart}`
              );
              const label = numeric.toFixed(3).replace('.', ',');

              setProduct({
                ...product,
                labelQuantity: label
              });
            }}
            onBlur={(e) => {
              const value = (e.target.value || '').replace(',', '.').trim();
              const parsed = parseFloat(value);

              if (!value || isNaN(parsed)) {
                setProduct({
                  ...product,
                  quantity: 0,
                  labelQuantity: '0,000'
                });
                return;
              }

              const rounded = parseFloat(parsed.toFixed(3));
              const label = rounded.toFixed(3).replace('.', ',');

              setProduct({
                ...product,
                quantity: rounded,
                labelQuantity: label
              });
            }}
          />

          <span className={`white ${isPhoneScreen ? 'ml3' : 'ml8'}`}>X</span>

          <TextField
            id="labelPrintProductNumberOfLabels"
            className="textFieldSmall right childInputP0 childInputW100 childInputFontSize20 numberOfLabelsField"
            placeholder=""
            variant="outlined"
            fullWidth
            type="text"
            value={product?.numberOfLabels || ''}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 4
            }}
            onChange={(e) => {
              const raw = e.target.value.replace(/\D/g, '');
              const numericValue = parseInt(raw, 10);

              if (!raw || isNaN(numericValue)) {
                setProduct({ ...product, numberOfLabels: '' });
                return;
              }

              setProduct({
                ...product,
                numberOfLabels: numericValue.toString()
              });
            }}
            onBlur={(e) => {
              const raw = e.target.value.replace(/\D/g, '');
              let parsed = parseInt(raw, 10);

              if (!parsed || parsed < 1) {
                parsed = 1;
              }

              setProduct({
                ...product,
                numberOfLabels: parsed.toString()
              });
            }}
          />

          <Button
            className={`printButton ${!product?.numberOfLabels && 'disabledButton'
              }`}
            design="outlined"
            label="IMPRIMIR"
            onClick={() => {
              if (!product?.numberOfLabels) return;

              const qtyText = (product?.labelQuantity || '')
                .toString()
                .replace(',', '.');
              const parsedQty = parseFloat(qtyText);
              const safeQty = Number.isFinite(parsedQty)
                ? parseFloat(parsedQty.toFixed(3))
                : 0;
              const safeNumLabels = Math.max(
                1,
                parseInt(product?.numberOfLabels, 10) || 1
              );

              const payload = {
                ...product,
                quantity: safeQty,
                labelQuantity: safeQty.toFixed(3).replace('.', ','),
                numberOfLabels: String(safeNumLabels)
              };

              if (safeNumLabels > 1) {
                setInternalDialogSettings(
                  internalDialogSettings.map((modal) =>
                    modal.name === 'confirmDialog'
                      ? { ...modal, open: true }
                      : modal
                  )
                );

                return;
              }

              onSubmit(payload);
            }}
            style={{ outline: 0 }}
          />
        </DialogActions>
      </section>

      {internalDialogSettings?.find((modal) => modal.name === 'confirmDialog')
        ?.open && (
          <ConfirmModal
            open={
              internalDialogSettings?.find(
                (modal) => modal.name === 'confirmDialog'
              )?.open
            }
            content={
              <Typography className="bold">
                Atenção! <br />
                Deseja fazer a impressão de {product?.numberOfLabels} etiquetas?
              </Typography>
            }
            onConfirm={() => {
              const qtyText = (product?.labelQuantity || '')
                .toString()
                .replace(',', '.');
              const parsedQty = parseFloat(qtyText);
              const safeQty = Number.isFinite(parsedQty)
                ? parseFloat(parsedQty.toFixed(3))
                : 0;
              const safeNumLabels = Math.max(
                1,
                parseInt(product?.numberOfLabels, 10) || 1
              );

              onSubmit({
                ...product,
                quantity: safeQty,
                labelQuantity: safeQty.toFixed(3).replace('.', ','),
                numberOfLabels: String(safeNumLabels)
              });

              setInternalDialogSettings(
                internalDialogSettings?.map((modal) =>
                  modal.name === 'confirmDialog'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
            onClose={() => {
              setInternalDialogSettings(
                internalDialogSettings?.map((modal) =>
                  modal.name === 'confirmDialog'
                    ? { ...modal, open: false }
                    : modal
                )
              );
            }}
            cancelText="Não"
            confirmText="Sim"
          />
        )}

      {internalDialogSettings.find(
        (modal) => modal.name === 'stockExtractDialog'
      ).open && (
          <StockExtractDialog
            open={
              internalDialogSettings.find(
                (modal) => modal.name === 'stockExtractDialog'
              ).open
            }
            onClose={() => {
              setInternalDialogSettings(
                internalDialogSettings.map((modal) =>
                  modal.name === 'stockExtractDialog'
                    ? { ...modal, open: false }
                    : modal
                )
              );
              history.push(`/etiquetas/catalogo/produtos/${paramsID}`);
            }}
            initialProduct={
              internalDialogSettings.find(
                (modal) => modal.name === 'stockExtractDialog'
              ).initialProduct || null
            }
            onSuccess={() => {
              updateMainList && updateMainList();
              setValidityFilterInfos({
                ...validityFilterInfos,
                content: validityFilterInfos?.content?.map((card) => {
                  if (card?.labelStatus === 'VALID') {
                    return {
                      ...card,
                      total: validityFilterInfos?.validCount - 1
                    };
                  }

                  return { ...card };
                }),
                loading: false
              });
            }}
            printLabel={(product) => {
              onSubmit(product, true);
            }}
            setModalSettings={setInternalDialogSettings}
          />
        )}

      <CommonAlert
        open={message?.description}
        onClose={() => setMessage({ description: '', status: '' })}
        severity={message?.status}
        indexMessage={message?.description}
        messagePersonal={message?.description}
      />
    </LabelPrintConfigDialogContainer>
  );
}

export default LabelPrintConfigDialog;
